module.exports = __webpack_public_path__ + "img/twitter icon.1dbf9c1a.png";